import React from 'react'
import View from './view.js'
import { useDataValue } from 'Simple/Data.js'

export default function Logic(props) {
  let patient_id = useDataValue({
    context: 'task',
    path: 'patient.id',
    viewPath: props.viewPath,
  })

  return (
    <View
      {...props}
      viewPatientPanel={patient_id && props.is_hovered}
      viewNo={!props.is_hovered}
    />
  )
}
